"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseTool_1 = require("./BaseTool");
const arcgis_1 = require("@terraformer/arcgis");
const geometry_engine_1 = __importDefault(require("./esri/geometry-engine"));
class PolygonAddTool extends BaseTool_1.BaseTool {
    constructor() {
        super(...arguments);
        this.hasFeatures = (featureCollection) => {
            return !!featureCollection.features.length;
        };
        this.onComplete = (existingFeatureCollection, newFeatureCollection, boundary) => __awaiter(this, void 0, void 0, function* () {
            // New feature
            const newFeature = newFeatureCollection.features[0].geometry;
            let newEsriPolygon = (0, arcgis_1.geojsonToArcGIS)(newFeature);
            const ge = yield geometry_engine_1.default.instance();
            if (boundary) {
                //find the boundary
                const boundaryPolygon = (0, arcgis_1.geojsonToArcGIS)(boundary.geometry);
                //Get source polygon intersecting with the boundary
                newEsriPolygon = ge.intersect(boundaryPolygon, newEsriPolygon);
            }
            if (newEsriPolygon) {
                // esri polygons of existing features
                const existingEsriPolygons = (0, arcgis_1.geojsonToArcGIS)(this.getGeometryCollection(existingFeatureCollection));
                const results = ge.union([...existingEsriPolygons, newEsriPolygon]);
                const geometries = (0, arcgis_1.arcgisToGeoJSON)(results);
                return this.getFeatureCollection([geometries]);
            }
            else {
                return existingFeatureCollection;
            }
        });
    }
}
exports.default = new PolygonAddTool();
